module.exports = __webpack_public_path__ + "static/media/editor-icon-bold.f4517d3f.svg";